import React, { FC } from 'react';
import AssignContainer from 'app/components/timeSavers/assignMultipleTasksModal/Container';
import Form from 'app/components/timeSavers/assignMultipleTasksModal/assignForm/Form';
import RequestContainer from 'app/components/timeSavers/assignMultipleTasksModal/RequestContainer';
import { PostStatus, STATUS } from '@kontentino/kontentino-constants/Posts';
import { Button, Icon } from '@kontentino/ui';
import { faUserPlus } from '@fortawesome/pro-regular-svg-icons/faUserPlus';
import { useTranslation } from 'react-i18next';
type Props = {
  postId: number;
  pageId: number;
  onUpdated(status: PostStatus): void;
};

const AssignTasksPopup: FC<Props> = ({ postId, pageId, onUpdated }) => {
  const { t } = useTranslation();

  return (
    <RequestContainer successCallback={() => onUpdated(STATUS.WAITING_FOR)}>
      {(requestParams) => (
        <AssignContainer
          onSubmit={requestParams.submitAssignTasks}
          preselectedValues={{
            posts: [postId],
            profiles: [pageId],
          }}
        >
          {(params) => (
            <>
              <Form
                pagesIds={params.selectedPagesIds}
                taskMessage={params.formState.taskMessage}
                isUrgent={params.formState.isUrgent}
                canSendEmail={params.formState.canSendEmailNotification}
                onSelectedUsersChange={params.handleChangeSelectedUsers}
                initialSelectedUsersIds={params.formState.selectedUsers}
                onTaskMessageChange={params.changeMessage}
                onSelectUrgent={params.selectUrgent}
                onSelectEmailNotification={params.selectEmailNotification}
                formErrors={params.formErrors}
              />
              <div className="tw-mt-4 tw-flex tw-justify-end">
                <Button
                  onClick={params.assignTasks}
                  iconBefore={<Icon icon={faUserPlus} />}
                  isLoading={requestParams.isLoading}
                  data-cy="assign-post-task-form-submit-button"
                >
                  {t('assignTask')}
                </Button>
              </div>
            </>
          )}
        </AssignContainer>
      )}
    </RequestContainer>
  );
};

export default AssignTasksPopup;
